import { mountFormContent } from '../form-content';
import type { GuideRenderContext } from '../types';
import { BaseRenderer } from './base-renderer';

/**
 * Renderiza una guía `form` (encuesta/NPS estilo Pendo): backdrop + tarjeta
 * centrada (mismo chrome que el modal) con los campos de `step.fields`.
 * Al enviar, las respuestas viajan vía `context.onFormSubmit` y el backend
 * las mergea como PROPIEDADES (`user_traits`) del usuario que respondió.
 *
 * El contenido (campos/envío/gracias) es compartido con `inline-form`
 * (ver `form-content.ts`); aquí solo va el chrome flotante.
 */
export class FormRenderer extends BaseRenderer {
  render(context: GuideRenderContext): void {
    const step = context.guide.guideSteps[0];
    if (!step || (step.fields ?? []).length === 0) return;

    const { root } = this.createHost();
    this.applyDesign(step.style);
    const doc = root.ownerDocument ?? document;

    const overlay = doc.createElement('div');
    overlay.className = 'veo-modal-overlay';
    const card = doc.createElement('div');
    card.className = 'veo-modal-card';

    mountFormContent(card, context, doc);
    overlay.appendChild(card);
    root.appendChild(overlay);

    const dismiss = (): void => {
      context.onInteraction({ guideId: context.guide.guideId, stepIndex: 0, action: 'dismissed' });
      context.onClose();
    };
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) dismiss();
    });
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') dismiss();
    };
    document.addEventListener('keydown', onKey);
    this.registerCleanup(() => document.removeEventListener('keydown', onKey));

    context.onInteraction({ guideId: context.guide.guideId, stepIndex: 0, action: 'shown' });
  }
}
